import { FC } from "preact/compat";
import { useSignal } from "@preact/signals";
import { useApp } from "~/core/store";
import { Button } from "~/components";
import { useTimeout } from "~/hooks";
import { DiscoveryDetailsRenderer } from "../DiscoveryDetailsRenderer";
import { DiscoveryItemContentProps } from "./interfaces";
import CopyIcon from "@material-design-icons/svg/outlined/content_copy.svg";
import PencilIcon from "@material-design-icons/svg/outlined/create.svg";
import DoneIcon from "@material-design-icons/svg/outlined/done.svg";
import Loader from "~/assets/loader.svg";
import cn from "classnames";

const DiscoveryItemContent: FC<DiscoveryItemContentProps> = ({
    tag,
    classNames,
    onClose,
}) => {
    const {
        api,
        help: {
            admin: { openEditor, isAdmin, getPrepublishContent },
        },
    } = useApp();
    const copied = useSignal(false);
    const delay = useTimeout(2000);
    const info = api.discovery.getByTag(tag);
    const prepublishContent = getPrepublishContent(tag);
    const loading = api.discovery.loading(tag);

    return (
        <>
            {loading.value && (
                <div class="flex w-[56px] justify-center py-4">
                    <Loader width="24" height="24" className="text-sky-500" />
                </div>
            )}
            {!loading.value && !info.value && (
                <div>We're still working on this manual</div>
            )}
            {info.value?.detailed && (
                <DiscoveryDetailsRenderer
                    details={prepublishContent?.content ?? info.value.detailed}
                />
            )}
            {isAdmin.value && (
                <div
                    className={cn(
                        "flex justify-between gap-x-4 text-sm",
                        classNames?.adminEdit,
                    )}
                >
                    <Button
                        variant="secondary"
                        onClick={() => {
                            onClose();
                            openEditor(tag);
                        }}
                        className="gap-x-2 text-black"
                    >
                        <PencilIcon width="16" height="16" />
                        <span>Edit</span>
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={async () => {
                            try {
                                await navigator.clipboard.writeText(tag);
                                copied.value = true;
                                delay(() => (copied.value = false));
                            } catch (err: unknown) {}
                        }}
                        className={cn(
                            "min-w-[115px] gap-x-2 fill-current",
                            copied.value ? "text-green-700" : "text-black",
                        )}
                    >
                        {copied.value ? (
                            <DoneIcon width="16" height="16" />
                        ) : (
                            <CopyIcon width="16" height="16" />
                        )}
                        <span>{copied.value ? "Copied" : "Copy tag"}</span>
                    </Button>
                </div>
            )}
        </>
    );
};

export default DiscoveryItemContent;
